module.exports = __webpack_public_path__ + "html/week1_2b0e67ae8ee824687a6011ff84556633.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/education/week1.html
// module id = CM5t
// module chunks = 151